import type { CreateStyled } from "@emotion/styled";

/**
 * This is for ignoring the props start with $, it's a workaround on emotion
 * refs: https://github.com/emotion-js/emotion/issues/2193#issuecomment-766173118
 */
export const transientOptions: Parameters<CreateStyled>[1] = {
  shouldForwardProp: (propertyName: string) => !propertyName.startsWith("$"),
};
